export default __webpack_public_path__ + "static/media/avatar_trex6.3daffe23.mp3";